<template>
<moo-dialog
    custom-class="email-preview-common-dialog email-preview-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    width="688px"
    :before-close="() => handleEmailPreviewDialog(false)"
  >
    <EmailTop
      :isPreview="true"
      @closePreview="handleEmailPreviewDialog(false)"
    ></EmailTop>
    <div class="content" id="emailPreview">
      <div v-html="html"></div>
    </div>
    <EmailBottom
      :isPreview="true"
      :loading="loading"
      @backToSend="backToSend"
      @sendEmail="sendEmail"
    ></EmailBottom>
  </moo-dialog>
</template>

<script>
import EmailTop from "./EmailTop.vue";
import EmailBottom from "./EmailBottom.vue";

export default {
  name: "EmailPreview",
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  emits: ["sendEmail", "backToSend"],
  components: {
    EmailTop,
    EmailBottom,
  },
  data() {
    return {
      visible: false,
      html: "",
      data: {},
    };
  },
  computed: {},
  methods: {
    handleEmailPreviewDialog(value) {
      this.visible = value;
    },
    updateEmailData(data) {
      this.data = data;
    },
    updatePreviewHtml(html) {
      this.html = html;
      //   setTimeout(() => {
      //     const previewEL = document.getElementById("emailPreview");
      //     const content = window.editor.view.dom.cloneNode(true);
      //     content.contentEditable = false;
      //     previewEL.appendChild(content);
      //   }, 1000);
    },
    backToSend() {
      this.$emit("backToSend");
    },
    sendEmail() {
      this.$emit("sendEmail", this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.email-preview-common-dialog {
  border-radius: 16px !important;
}
.email-preview-dialog {
  .moo-dialog__body {
    @property --var1 {
      syntax: "<color>";
      inherits: true;
      initial-value: transport;
    }
    .content::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: var(--var1) !important;
    }

    .content {
      --var1: #f5f6f7;
      margin: 16px 24px;
      height: 480px;
      overflow-y: scroll;
      overflow-x: scroll;
    }
  }
}
</style>
